// extracted by mini-css-extract-plugin
export default {"cadastro":"Cadastro_cadastro__TpR7h","cadastro__form":"Cadastro_cadastro__form__Oy21y","radioGroup":"Cadastro_radioGroup__RbNMG","btnHeader":"Cadastro_btnHeader__5j-wE"};